<template>
  <section class="youtube-section">
    <div class="container">
      <div class="youtube-pic-container">
        <img
          :src="require('@/assets/image/youtube-section/youtube.png')"
          alt="youtube"
          class="youtube">
        <div class="count-youtube">
          <span class="count-youtube__views" id="counterViewsContainer">7 450 593 204</span>
          <span class="count-youtube__text"> просмотров</span>
        </div>
      </div>
      <div class="youtube-text-container">
        <div class="about">
          <div class="about__heading">
            <span>№3</span> На YouTube <br> снова побит рекорд
          </div>
          <div class="about__text">
            Клип на детскую песню Baby Shark стал рекордсменом
            YouTube за всю историю сервиса. Это первый в мире
            ролик, который собрал 7,4 млрд просмотров. Еще год
            назад мы думали, что потребуется несколько лет,
            чтобы обогнать хит Despasito <br><br>
            В 2021 году МТС удивит вас новыми продуктами
            для семьи
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap, TweenMax } from 'gsap';

export default {
  name: 'v-youtube-section',
  mounted() {
    const timelineYoutube = gsap.timeline({
      scrollTrigger: {
        trigger: '.youtube-section',
        start: '-=40%',
        end: '0%',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress_youtube:', self.progress);
          document.body.style.background = '#F4F4F4';
          let counterViews = 7450593204 * self.progress;
          counterViews = counterViews.toFixed(0);
          counterViews = new Intl.NumberFormat('ru-RU').format(counterViews);
          const counterViewsContainer = document.getElementById('counterViewsContainer');
          TweenMax.to('.mars', {
            opacity: 0,
          });
          counterViewsContainer.innerHTML = counterViews;
        },
      },
    });
    timelineYoutube.addLabel('start');
  },
};
</script>

<style lang="scss">
.youtube-section {
  position: relative;
  padding-top: 100px;
  min-height: unset;

  .container {
    position: sticky;
    top: 30px;
  }
}
.youtube-pic-container{
  max-width: 340px;
  height: 284px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 50px;
  position: relative;

  img{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    max-width: 100%;
    z-index: 9;
  }

  .count-youtube{
    position: absolute;
    bottom: 58px;
    z-index: 10;
    font-size: 18px;
    color: #697884;
    left: 12px;
  }
}
</style>
